import { render, staticRenderFns } from "./CreateLocalDocumentationStep.vue?vue&type=template&id=c265d054"
import script from "./CreateLocalDocumentationStep.vue?vue&type=script&lang=js"
export * from "./CreateLocalDocumentationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports